import React, { useState } from "react";
import axios from "axios";
import FileDownload from "js-file-download";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Vulnerability List
export const fetchVulnerabilityData = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/${companyProfileID}/Details`
    );

    // console.log("fetchVulnerabilityList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Vulnerability
export const addVulnerability = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability`,
      payload
    );
    // console.log("addVulnerability res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Edit Vulnerability
export const editVulnerability = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability`,
      payload
    );
    // console.log("editVulnerability res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Vulnerability
export const deleteVulnerability = async (
  userId: number,
  vulnerabilityId: any
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/Delete?id=${vulnerabilityId}&updatedby=${userId}`
    );
    // console.log("deleteVulnerability res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Import Vulnerability List
export const getImportVulnerabilityList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/Import/Details`
    );
    // console.log("getImportVulnerabilityList res", res.data);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Import New Vulnerability
export const importNewVulnerability = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/Import/Create`,
      payload
    );
    // console.log("importNewVulnerability res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const getExistingVenurability = async (
  companyProfileID: number,
  vulnerabilityIds: number[]
) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Venurability/${companyProfileID}/Exist`, vulnerabilityIds
    );
    // console.log("getExistingVenurability res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
//Delete Multiple Vulnerablities List
export const deleteIVulnerablitiesMultiple = async (
  userId: number,
  payload: number[]

): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/Delete-All?updatedby=${userId}`, payload
    );
    return response.data;
  } catch (error) {
    return error;
  }
};